module.exports = __webpack_public_path__ + "static/media/MSC.93789d33.svg";